"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Shortcode = _interopRequireDefault(require("./Shortcode"));

var Matcher = /*#__PURE__*/function () {
  function Matcher(text) {
    (0, _classCallCheck2["default"])(this, Matcher);
    this.text = text || '';
    this.shortcodes = [];
    this.currentOpen = null;
    this.braces = ['[[', ']]'];
    this.find();
  }

  (0, _createClass2["default"])(Matcher, [{
    key: "find",
    value: function find() {
      for (var i = 0; i < this.text.length; i += 1) {
        var current = this.text[i] + this.text[i + 1];
        var match = current === this.braces[0] || current === this.braces[1];

        if (match) {
          if (this.currentOpen === null) {
            this.currentOpen = i;
          } else {
            this.shortcodes.push(new _Shortcode["default"](this.currentOpen, i + 1, this.text.substring(this.currentOpen + 2, i)));
            this.currentOpen = null;
          }
        }
      }
    }
  }]);
  return Matcher;
}();

var _default = Matcher;
exports["default"] = _default;